<template>
  <div>
    <h4
      class="card-title font-weight-bold"
      style="margin-bottom: 40px"
    >
      Gesetzliche Mindestlöhne verwalten
    </h4>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
      class="col-12 mt-4"
    />
    <u-loader
      v-if="
        isLoading ||
          !this.$store.state.mindestLohnKonfiguration.Cities ||
          this.$store.state.mindestLohnKonfiguration.Cities.length == 0
      "
    />
    <div v-else>
      <div
        v-for="(year, index) in years"
        :key="index"
        class="groupingWrapper w-100"
      >
        <div
          class="groupingTitle py-2"
          @click="
            expandedYear != year ? (expandedYear = year) : (expandedYear = '')
          "
        >
          <i
            v-if="expandedYear == year"
            class="fa fa-chevron-down mr-4 width20"
          />
          <i
            v-else
            class="fas fa-chevron-right mr-4 width20"
            placement="bottom"
          />
          <span>{{ year }}</span>
        </div>
        <minimum-wage-table
          v-if="
            minimumWagesPerYear[year].wages &&
              minimumWagesPerYear[year].wages.length != 0 &&
              year == expandedYear
          "
          :wages="minimumWagesPerYear[year].wages"
          @deleteWage="(wageToDelete) => openDeleteDialog(wageToDelete)"
          @editWage="(wageToEdit) => openEditSalaryDialog(wageToEdit)"
        />
        <div
          v-if="year == expandedYear"
          class="groupingContent"
        >
          <div
            v-for="(canton, cantonIndex) in minimumWagesPerYear[year].cantons"
            :key="cantonIndex"
          >
            <div
              class="groupingTitle py-1 pl-4"
              @click="
                expandedCanton != canton
                  ? (expandedCanton = canton)
                  : (expandedCanton = '')
              "
            >
              <i
                v-if="expandedCanton == canton"
                class="fa fa-chevron-down mr-4 width20"
              />
              <i
                v-else
                class="fas fa-chevron-right mr-4 width20"
                placement="bottom"
              />
              <span>{{
                $store.state.mindestLohnKonfiguration.Cities.filter(
                  (x) => x.cantonCode == canton,
                )[0].canton
              }}</span>
            </div>
            <minimum-wage-table
              v-if="
                minimumWagesPerYear[year][canton].wages &&
                  minimumWagesPerYear[year][canton].wages.length != 0 &&
                  canton == expandedCanton
              "
              :wages="minimumWagesPerYear[year][canton].wages"
              @deleteWage="(wageToDelete) => openDeleteDialog(wageToDelete)"
              @editWage="(wageToEdit) => openEditSalaryDialog(wageToEdit)"
            />
            <div
              v-if="canton == expandedCanton"
              class="groupingContent"
            >
              <div
                v-for="(district, districtIndex) in minimumWagesPerYear[year][
                  canton
                ].districts"
                :key="districtIndex"
              >
                <div
                  class="groupingTitle py-1 pl-5"
                  @click="
                    expandedDistrict != district
                      ? (expandedDistrict = district)
                      : (expandedDistrict = '')
                  "
                >
                  <i
                    v-if="expandedDistrict == district"
                    class="fa fa-chevron-down mr-4 width20"
                  />
                  <i
                    v-else
                    class="fas fa-chevron-right mr-4 width20"
                    placement="bottom"
                  />
                  <span>{{
                    $store.state.mindestLohnKonfiguration.Cities.filter(
                      (x) => x.districtCode == district,
                    )[0].district
                  }}</span>
                </div>
                <minimum-wage-table
                  v-if="
                    minimumWagesPerYear[year][canton][district].wages &&
                      minimumWagesPerYear[year][canton][district].wages.length !=
                      0 &&
                      district == expandedDistrict
                  "
                  :wages="minimumWagesPerYear[year][canton][district].wages"
                  class="pl-3"
                  @deleteWage="(wageToDelete) => openDeleteDialog(wageToDelete)"
                  @editWage="(wageToEdit) => openEditSalaryDialog(wageToEdit)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="$IsUserInRole('GesetzlicheMindestloehneVerwaltung')"
      class="mt-4 mb-4"
      style="text-align: right"
    >
      <span>
        <button
          class="btn btn-success"
          placement="bottom"
          type="button"
          @click.stop="openNewSalaryDialog()"
        >
          <i class="fas fa-plus" />
        </button>
      </span>
    </div>

    <b-modal
      id="deleteMinimumSalary"
      ref="deleteMinimumSalary"
      hide-footer
      no-fade
      title="Kantonalen Mindestlohn löschen"
    >
      <div class="d-block mb-4">
        <u-error-handling
          v-if="deleteErrorObject"
          :error-object="deleteErrorObject"
        />
        Sind Sie sicher, dass Sie diese Mindestlohnkonfiguration löschen
        möchten?
      </div>
      <b-button
        variant="success"
        @click="deleteMinimumSalary()"
      >
        Ok
      </b-button>
      <b-button
        class="ml-2"
        variant="danger"
        @click="hideModal('deleteMinimumSalary')"
      >
        Abbrechen
      </b-button>
    </b-modal>

    <b-modal
      id="editSalary"
      ref="editSalary"
      :title="editTitle"
      hide-footer
      no-fade
      size="xl"
    >
      <u-error-handling
        v-if="errorObject"
        :error-object="editErrorObject"
      />
      <div v-if="salaryToEdit != null">
        <div class="row mb-2">
          <div class="col-4 font-weight-bold">
            Jahr
          </div>
          <div class="col-8">
            <v-select
              v-model="salaryToEdit.year"
              :disabled="!isNewSalary"
              :items="yearsToSelect"
              label="Jahr"
            />
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-4 font-weight-bold">
            Monat
          </div>
          <div class="col-1 pt-4">
            Von
          </div>
          <div class="col-3">
            <v-select
              v-model="salaryToEdit.fromMonth"
              :disabled="!isNewSalary"
              :items="monthList"
              item-text="text"
              item-value="id"
              label="Monat"
              @change="
                (month) => {
                  validateMonthRange(
                    salaryToEdit.fromMonth,
                    salaryToEdit.toMonth,
                  );
                  if (
                    salaryToEdit.year &&
                    month !== undefined &&
                    month !== null
                  ) {
                    const localDate = new Date(salaryToEdit.year, month, 1);
                    localDate.setMinutes(
                      localDate.getMinutes() - localDate.getTimezoneOffset(),
                    );
                    salaryToEdit.validFrom = localDate.toISOString();
                  }
                }
              "
            />
          </div>
          <div class="col-1 pt-4">
            Bis
          </div>
          <div class="col-3">
            <v-select
              v-model="salaryToEdit.toMonth"
              :disabled="!isNewSalary"
              :items="monthList"
              item-text="text"
              item-value="id"
              label="Monat"
              @change="
                (month) => {
                  validateMonthRange(
                    salaryToEdit.fromMonth,
                    salaryToEdit.toMonth,
                  );
                  if (
                    salaryToEdit.year &&
                    month !== undefined &&
                    month !== null
                  ) {
                    const localDate = new Date(salaryToEdit.year, month + 1, 0);
                    localDate.setMinutes(
                      localDate.getMinutes() - localDate.getTimezoneOffset(),
                    );
                    salaryToEdit.validTo = localDate.toISOString();
                  }
                }
              "
            />
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-4 font-weight-bold">
            Kanton (Leerlassen falls gültig für ganze Schweiz)
          </div>
          <div class="col-8">
            <v-select
              v-model="selectedCanton"
              :disabled="!isNewSalary"
              :items="getCantonOptions()"
              item-text="text"
              item-value="id"
              label="Kanton"
              return-object
              clearable
            />
          </div>
        </div>
        <div
          v-if="selectedCanton"
          class="row mb-2"
        >
          <div class="col-4 font-weight-bold">
            Bezirk (Leerlassen falls gültig für ganzen Kanton)
          </div>
          <div class="col-8">
            <v-select
              v-model="selectedDistrict"
              :disabled="!isNewSalary"
              :items="getDistrictOptions(selectedCanton)"
              item-text="text"
              item-value="id"
              label="Bezirk"
              return-object
              clearable
            />
          </div>
        </div>
        <div
          v-if="selectedCanton && selectedDistrict"
          class="row mb-2"
        >
          <div class="col-4 font-weight-bold">
            Ortschaft (Leerlassen falls gültig für ganzen Bezirk)
          </div>
          <div class="col-8">
            <v-select
              v-model="selectedCity"
              :disabled="!isNewSalary"
              :items="getCityOptions(selectedCanton, selectedDistrict)"
              item-text="text"
              item-value="id"
              label="Ortschaft"
              multiple
              return-object
              clearable
            />
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-4 font-weight-bold">
            Mindest Basisstundenlohn wenn kein 13. Monatslohn
          </div>
          <div class="col-8">
            <v-text-field
              v-model="salaryToEdit.mindeststundenlohn"
              label="Mindest Basisstundenlohn wenn kein 13. Monatslohn"
            />
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-4 font-weight-bold">
            Mindest Basisstundenlohn wenn 13. Monatslohn
          </div>
          <div class="col-8">
            <v-text-field
              v-model="salaryToEdit.mindeststundenlohnPlus13ML"
              label="Mindest Basisstundenlohn wenn 13. Monatslohn"
            />
          </div>
        </div>
      </div>
      <v-alert
        :value="validationMessage && validationMessage != ''"
        color="warning"
        icon="priority_high"
        outline
      >
        {{ validationMessage }}
      </v-alert>
      <br>
      <b-button
        v-if="salaryToEdit && !isNewSalary"
        variant="success"
        @click="saveSalary()"
      >
        Speichern
      </b-button>
      <b-button
        v-else
        :disabled="validationMessage && validationMessage != ''"
        variant="success"
        @click="createSalary()"
      >
        Hinzufügen
      </b-button>
      <b-button
        class="ml-2"
        variant="danger"
        @click="hideModal('editSalary')"
      >
        Abbrechen
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import {
  GetCantonalMinimumWages,
  CreateCantonalMinimumWage,
  SaveCantonalMinimumWage,
  DeleteCantonalMinimumWage,
} from "@/services/minimum.wage.services/canton.minimum.wages.js";

import MinimumWageTable from "@/components/legalMinimumWage/MinimumWageTable.vue";

export default {
  components: {
    MinimumWageTable,
  },
  data() {
    return {
      isLoading: false,
      errorObject: null,
      editErrorObject: null,
      deleteErrorObject: null,
      expandedYear: null,
      expandedCanton: null,
      expandedDistrict: null,
      salaryToDelete: null,
      salaryToEdit: null,
      isNewSalary: false,
      editTitle: "",
      validationMessage: null,
      minimumWages: [],
      minimumWagesPerYear: {},
      years: [],
      yearsToSelect: [],

      rowsPerPage: [{ text: "Alle", value: -1 }, 10, 25, 50, 100],
      plzLevels: [
        { id: 1, value: "Land" },
        { id: 2, value: "Kanton" },
        { id: 3, value: "Bezirk" },
        { id: 4, value: "Postleitzahl" },
      ],
      cityOptions: [],
      selectedCanton: null,
      selectedDistrict: null,
      selectedCity: [],
    };
  },
  computed: {
    salaryPath() {
      let paths = [];

      if (this.selectedCity && this.selectedCity.length > 0) {
        this.selectedCity.forEach((city) => {
          let path = this.getPlzPath(
            this.selectedCanton,
            this.selectedDistrict,
            city,
          );

          paths.push(path);
        });
      } else {
        let path = this.getPlzPath(
          this.selectedCanton,
          this.selectedDistrict,
          null,
        );
        paths.push(path);
      }

      return paths;
    },
    canUserEdit() {
      //TODO: Nur Benutzer mit der Berechtigung Gesetzliche Mindestlöhne Definieren können diese Anpassen.
      //TODO: Alle für das Admin berechtigte Benutzer haben das Recht die gesetzlichen Mindestlöhne einzusehen.
      // return this.$IsUserInRole("VertragsmanagementVerwaltung");
      return true;
    },
    monthList() {
      const year = new Date().getFullYear();
      const monthList = [...Array(12).keys()];
      const formatter = new Intl.DateTimeFormat("de", {
        month: "long",
      });

      const getMonthName = (monthIndex) =>
        formatter.format(new Date(year, monthIndex));

      return monthList.map((x) => {
        return { id: x, text: getMonthName(x) };
      });
    },
  },
  watch: {
    salaryPath(newVal) {
      if (!this.salaryToEdit) {
        return;
      }
      if (!this.selectedCity || this.selectedCity.length == 0) {
        this.salaryToEdit.path = newVal ? newVal[0] : "CH/";
      }
    },

    "$store.state.mindestLohnKonfiguration.Cities": function () {
      this.loadMinimumWages();
      var currentYear = new Date().getFullYear();
      for (var nextYear = 2005; nextYear <= currentYear + 3; nextYear++) {
        this.yearsToSelect.push(nextYear);
      }
    },
  },
  created() {
    if (
      !this.$store.state.mindestLohnKonfiguration.Cities ||
      this.$store.state.mindestLohnKonfiguration.Cities.length == 0
    ) {
      this.$store.dispatch("getAllCities");
    } else {
      this.loadMinimumWages();
      var currentYear = new Date().getFullYear();
      for (var nextYear = 2005; nextYear <= currentYear + 3; nextYear++) {
        this.yearsToSelect.push(nextYear);
      }
    }
  },
  methods: {
    getCantonOptions() {
      let allCities = this.$store.state.mindestLohnKonfiguration.Cities;
      let cantonIds = [...new Set(allCities.map((x) => x.cantonId))];
      let cantons = [];
      cantonIds.map((x) => {
        let canton = allCities.filter((city) => city.cantonId == x)[0];
        cantons.push({
          id: canton.cantonId,
          text: `${canton.cantonCode} ${canton.canton}`,
          code: canton.cantonCode,
        });
      });
      return cantons;
    },
    getDistrictOptions(canton) {
      let allCities = this.$store.state.mindestLohnKonfiguration.Cities;
      let citiesOfCanton = allCities.filter(
        (city) => city.cantonId === canton.id,
      );
      let districtCodes = [
        ...new Set(citiesOfCanton.map((x) => x.districtCode)),
      ];

      let districts = [];
      districtCodes.map((x) => {
        let district = citiesOfCanton.filter(
          (city) => city.districtCode == x,
        )[0];
        districts.push({
          id: district.districtCode,
          text: `${district.district} (${district.cantonCode})`,
        });
      });
      return districts;
    },
    getCityOptions(canton, district) {
      let allCities = this.$store.state.mindestLohnKonfiguration.Cities;
      let citiesOfCantonAndDistrict = allCities.filter(
        (city) =>
          city.cantonId === canton.id && city.districtCode == district.id,
      );
      let cityIds = [...new Set(citiesOfCantonAndDistrict.map((x) => x.onrp))];
      let cities = [];
      cityIds.map((x) => {
        let city = citiesOfCantonAndDistrict.filter(
          (city) => city.onrp == x,
        )[0];
        cities.push({
          id: city.cityId,
          text: `${city.plz} ${city.city} (${city.district}, ${
            city.cantonCode
          })`,
          plz: city.plz,
          onrp: city.onrp,
        });
      });
      cities = cities.sort((a, b) => {
        return a.plz > b.plz ? 1 : -1;
      });
      return cities;
    },
    getPlzPath(canton, district, city) {
      let path = "CH";
      path = canton ? path + `/${canton.code}` : path;
      path = district ? path + `/${district.id}` : path;
      path = city ? path + `/${city.onrp}` : path;

      return path;
    },
    validateMonthRange(fromMonth, toMonth) {
      if (fromMonth > toMonth) {
        this.validationMessage = "Der Startmonat muss vor dem Endmonat liegen.";
        return false;
      }
      this.validationMessage = null;
      return true;
    },
    hideModal(modalId) {
      this.$refs[modalId].hide();
    },
    showModal(modalId) {
      this.$refs[modalId].show();
    },
    loadMinimumWages() {
      this.isLoading = true;
      this.minimumWagesPerYear = {};

      GetCantonalMinimumWages(
        (response) => {
          this.isLoading = false;
          this.minimumWages = response;

          this.years = [];
          this.minimumWages.map((wage) => {
            let wageYear = new Date(wage.validFrom).getFullYear();
            wage.year = wageYear;
            wage.fromMonth = new Date(wage.validFrom).getMonth();
            wage.toMonth = new Date(wage.validTo).getMonth();
            if (this.years.indexOf(wageYear) == -1) {
              this.years.push(wageYear);
            }

            if (wageYear == new Date().getFullYear()) {
              this.expandedYear = wageYear;
            }

            let pathPieces = wage.path.split("/");
            let cantonCode = pathPieces[1] ? pathPieces[1] : null;
            let districtCode = pathPieces[2] ? pathPieces[2] : null;
            let plz = pathPieces[3] ? pathPieces[3] : null;

            if (this.minimumWagesPerYear[wageYear] == null) {
              this.minimumWagesPerYear[wageYear] = {
                wages: [],
                cantons: [],
              };
            }

            if (
              cantonCode &&
              this.minimumWagesPerYear[wageYear][cantonCode] == null
            ) {
              this.minimumWagesPerYear[wageYear][cantonCode] = {
                wages: [],
                districts: [],
              };
            }

            if (
              districtCode &&
              this.minimumWagesPerYear[wageYear][cantonCode][districtCode] ==
                null
            ) {
              this.minimumWagesPerYear[wageYear][cantonCode][districtCode] = {
                wages: [],
              };
            }

            if (!cantonCode && !districtCode && !plz) {
              this.minimumWagesPerYear[wageYear].wages.push(wage);
            }
            if (cantonCode && !districtCode && !plz) {
              this.minimumWagesPerYear[wageYear].wages.push(wage);
            }
            if (cantonCode && districtCode && !plz) {
              this.minimumWagesPerYear[wageYear][cantonCode].wages.push(wage);
              if (
                this.minimumWagesPerYear[wageYear].cantons.indexOf(
                  cantonCode,
                ) == -1
              ) {
                this.minimumWagesPerYear[wageYear].cantons.push(cantonCode);
              }
            }

            if (cantonCode && districtCode && plz) {
              let existingWage = this.minimumWagesPerYear[wageYear][cantonCode][
                districtCode
              ].wages.filter(
                (x) =>
                  x.mindeststundenlohn == wage.mindeststundenlohn &&
                  x.mindeststundenlohnPlus13ML ==
                    wage.mindeststundenlohnPlus13ML,
              )[0];
              if (existingWage) {
                existingWage.path = existingWage.path + ";" + wage.path;
              } else {
                this.minimumWagesPerYear[wageYear][cantonCode][
                  districtCode
                ].wages.push(wage);
              }

              if (
                this.minimumWagesPerYear[wageYear].cantons.indexOf(
                  cantonCode,
                ) == -1
              ) {
                this.minimumWagesPerYear[wageYear].cantons.push(cantonCode);
              }
              if (
                this.minimumWagesPerYear[wageYear][
                  cantonCode
                ].districts.indexOf(districtCode) == -1
              ) {
                this.minimumWagesPerYear[wageYear][cantonCode].districts.push(
                  districtCode,
                );
              }
            }
          });

          this.years.sort((a, b) => {
            return a > b ? 1 : -1;
          });
          if (this.expandedYear == null) {
            this.expandedYear = this.years[this.years.length - 1];
          }
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
    saveSalary() {
      this.editErrorObject = null;
      let salaryToSave = JSON.parse(JSON.stringify(this.salaryToEdit));

      //If months not set, set full year
      if (
        salaryToSave.year &&
        (!salaryToSave.validFrom || !salaryToSave.validTo)
      ) {
        const localFromDate = new Date(salaryToSave.year, 0, 1);
        localFromDate.setMinutes(
          localFromDate.getMinutes() - localFromDate.getTimezoneOffset(),
        );
        salaryToSave.validFrom = localFromDate.toISOString();

        const localToDate = new Date(salaryToSave.year, 11, 31);
        localToDate.setMinutes(
          localToDate.getMinutes() - localToDate.getTimezoneOffset(),
        );
        salaryToSave.validTo = localToDate.toISOString();
      }

      if (this.selectedCity && this.selectedCity.length > 0) {
        let saveSalaryPromises = [];

        this.selectedCity.forEach((city) => {
          const citySalaryToSave = JSON.parse(JSON.stringify(salaryToSave));
          citySalaryToSave.path = this.getPlzPath(
            this.selectedCanton,
            this.selectedDistrict,
            city,
          );
          saveSalaryPromises.push(
            new Promise((resolve, reject) => {
              SaveCantonalMinimumWage(
                citySalaryToSave,
                () => {
                  resolve();
                },
                (error) => {
                  reject(error);
                  this.editErrorObject = error;
                },
              );
            }),
          );
        });

        Promise.all(saveSalaryPromises).then(() => {
          this.loadMinimumWages();
          this.hideModal("editSalary");

          this.salaryToEdit = null;
          this.selectedCanton = null;
          this.selectedDistrict = null;
          this.selectedCity = [];
        });
      } else {
        salaryToSave.path = this.salaryPath[0];

        SaveCantonalMinimumWage(
          salaryToSave,
          () => {
            this.loadMinimumWages();
            this.hideModal("editSalary");

            this.salaryToEdit = null;
            this.selectedCanton = null;
            this.selectedDistrict = null;
            this.selectedCity = [];
          },
          (error) => {
            this.editErrorObject = error;
          },
        );
      }
    },
    createSalary() {
      this.editErrorObject = null;

      let salaryToSave = JSON.parse(JSON.stringify(this.salaryToEdit));

      //If months not set, set full year
      if (
        salaryToSave.year &&
        (!salaryToSave.validFrom || !salaryToSave.validTo)
      ) {
        const localFromDate = new Date(salaryToSave.year, 0, 1);
        localFromDate.setMinutes(
          localFromDate.getMinutes() - localFromDate.getTimezoneOffset(),
        );
        salaryToSave.validFrom = localFromDate.toISOString();

        const localToDate = new Date(salaryToSave.year, 11, 31);
        localToDate.setMinutes(
          localToDate.getMinutes() - localToDate.getTimezoneOffset(),
        );
        salaryToSave.validTo = localToDate.toISOString();
      }

      if (this.selectedCity && this.selectedCity.length > 0) {
        let saveSalaryPromises = [];

        this.selectedCity.forEach((city) => {
          const citySalaryToSave = JSON.parse(JSON.stringify(salaryToSave));
          citySalaryToSave.path = this.getPlzPath(
            this.selectedCanton,
            this.selectedDistrict,
            city,
          );
          saveSalaryPromises.push(
            new Promise((resolve, reject) => {
              CreateCantonalMinimumWage(
                citySalaryToSave,
                () => {
                  resolve();
                },
                (error) => {
                  reject(error);
                  this.editErrorObject = error;
                },
              );
            }),
          );
        });

        Promise.all(saveSalaryPromises).then(() => {
          this.loadMinimumWages();
          this.hideModal("editSalary");

          this.salaryToEdit = null;
          this.selectedCanton = null;
          this.selectedDistrict = null;
          this.selectedCity = [];
        });
      } else {
        salaryToSave.path = this.salaryPath[0];
        CreateCantonalMinimumWage(
          salaryToSave,
          () => {
            this.loadMinimumWages();
            this.hideModal("editSalary");

            this.salaryToEdit = null;
            this.selectedCanton = null;
            this.selectedDistrict = null;
            this.selectedCity = [];
          },
          (error) => {
            this.editErrorObject = error;
          },
        );
      }
    },
    deleteMinimumSalary() {
      this.isLoading = true;
      this.deleteErrorObject = null;

      let paths = this.salaryToDelete.path.split(";");
      let deletePromises = [];

      paths.forEach((path) => {
        deletePromises.push(
          new Promise((resolve, reject) => {
            DeleteCantonalMinimumWage(
              this.salaryToDelete.year,
              encodeURIComponent(path.replaceAll("/", "|")),
              this.salaryToDelete.fromMonth,
              this.salaryToDelete.toMonth,
              () => {
                resolve();
              },
              (error) => {
                reject(error);
                this.isLoading = false;
                this.deleteErrorObject = error;
              },
            );
          }),
        );
      });

      Promise.all(deletePromises).then(() => {
        this.loadMinimumWages();
        this.hideModal("deleteMinimumSalary");
        this.salaryIdToDelete = null;
      });
    },
    openDeleteDialog(salary) {
      this.salaryToDelete = salary;
      this.showModal("deleteMinimumSalary");
    },
    openNewSalaryDialog() {
      this.editTitle = "Mindestlohn erfassen";
      this.salaryToEdit = {
        path: "CH",
        year: "",
        mindeststundenlohn: "0.00",
        mindeststundenlohnPlus13ML: "0.00",
      };
      this.isNewSalary = true;
      this.showModal("editSalary");
    },
    openEditSalaryDialog(salary) {
      this.editTitle = "Mindestlohn bearbeiten";
      this.salaryToEdit = salary;
      let wagePaths = salary.path.split(";");

      wagePaths.forEach((path) => {
        let pathPieces = path.split("/");
        this.selectedCanton = pathPieces[1]
          ? this.getCantonOptions().filter((x) => x.code == pathPieces[1])[0]
          : null;
        this.selectedDistrict = pathPieces[2]
          ? this.getDistrictOptions(this.selectedCanton).filter(
              (x) => x.id == pathPieces[2],
            )[0]
          : null;
        if (pathPieces[3]) {
          this.selectedCity.push(
            this.getCityOptions(
              this.selectedCanton,
              this.selectedDistrict,
            ).filter((x) => x.onrp == pathPieces[3])[0],
          );
        }
      });

      this.isNewSalary = false;
      this.showModal("editSalary");
    },
  },
};
</script>

<style scoped>
.groupingWrapper {
  border-bottom: 1px solid rgb(200, 200, 200);
}

.groupingTitle {
  font-size: 1.2rem;
  cursor: pointer;
  font-weight: bold;
  border-bottom: 1px solid rgb(235, 235, 235);
}

.smallActionButton {
  width: 30px;
  height: 30px;
  font-size: 17px;
  padding: 0px;
}
</style>
